export interface ApprovalSyncFieldError {
  fieldId: string;
  code?: string;
  missingValues: string[];
  message?: string;
}

// errorDetails is untyped JSON from the engine — guard the shape defensively.
export function parseApprovalSyncFieldErrors(
  errorDetails: unknown,
): ApprovalSyncFieldError[] {
  if (!errorDetails || typeof errorDetails !== "object") return [];
  const raw = (errorDetails as { fieldErrors?: unknown }).fieldErrors;
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((entry): ApprovalSyncFieldError[] => {
    if (!entry || typeof entry !== "object") return [];
    const e = entry as Record<string, unknown>;
    if (typeof e.fieldId !== "string" || e.fieldId.length === 0) return [];
    return [
      {
        fieldId: e.fieldId,
        code: typeof e.code === "string" ? e.code : undefined,
        missingValues: Array.isArray(e.missingValues)
          ? e.missingValues.filter((v): v is string => typeof v === "string")
          : [],
        message: typeof e.message === "string" ? e.message : undefined,
      },
    ];
  });
}
